import { VisitOfficeForm } from "QuorumGrassroots/campaign-forms/components/VisitOfficeForm"
import { getMessageFormWrapper } from "QuorumGrassroots/campaign-forms/wrappers/GetMessagesFormWrapper"
import { generateVisitOfficeActions } from "QuorumGrassroots/campaign-forms/grassrootsActionGenerators"

export default getMessageFormWrapper({
    formName: "visit_office",
    generateGrassrootsActions: generateVisitOfficeActions,
    getIdFromMessage: (message) => message.target.id.toString(),
})(VisitOfficeForm)
